import { CheckBoxWidget, TabStyles } from '@tableau/widgets';
import { BodyCell, DataGrid, HeaderColumn } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { CommonDataGridColumns } from '../../common/react/CommonDataGridColumns';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { FlowOutputStepInfo } from '../../ts/models/FlowOutputStepInfo';

export module FlowOutputStepGrid {

  export function columns(
    isCheckboxHeaderChecked: boolean,
    onCheckboxHeaderClicked: () => void,
    onCheckboxClicked: (row: DataGrid.Row) => void,
    outputsSelected: { readonly [key: string]: boolean },
    isDisabled?: boolean,
  ): DataGrid.Column[] {
    const columns: DataGrid.Column[] = [];

    const isSelected = (rowKey: string) => {
      return outputsSelected[rowKey];
    };

    columns.push(CommonDataGridColumns.withExtraSpace({
      name: 'output-steps',
      dataKey: 'flowOutputSteps',
      headerText: Messages.outputSteps(),
      sortable: false,
      headerFormatter: DataGridCells.CheckboxHeaderWithText(isCheckboxHeaderChecked, onCheckboxHeaderClicked, isDisabled),
      cellFormatter: DataGridCells.CheckboxCellWithText('name', isSelected, onCheckboxClicked, isDisabled)
    }));

    columns.push({
      name: 'output-names-col',
      dataKey: 'flowOutputStepsName',
      headerText: Messages.flowOverviewOutputName(),
      sortable: false,
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('datasourceName')
    });

    columns.push({
      name: 'output-types-col',
      dataKey: 'flowOutputStepsType',
      headerText: Messages.flowScheduledTaskLocation(),
      sortable: false,
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCellWithTransform('dataConnection',
      (dataConnection) => dataConnection.connectionTypeDisplayName)
    });

    return columns;
  }
}

